import React from "react";
import { useSelector } from "react-redux";

import SelectBox from "components/SelectBox";
import CollapsibleTable from "../table/CollapsibleTable";

import StoresDropDown from "components/General/StoresDropDown";
import { useEffect } from "react";
import { Button, Box, Grid } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import { setAllItems, addMultipleSelect } from "redux/dropDownStores";
import { setItemsList } from "redux/dropDownStores";
import { useDispatch } from "react-redux";
import axios from "axios";
import Backdrop from "@mui/material/Backdrop";
import { Bars } from "react-loader-spinner";
import { useSuspiciousTransactions, useUpdateTransaction } from "hooks/useSuspicious";
import { API_BASE } from "utils/api";

function SuspiciousTable() {
  const [startDate, setStartDate] = React.useState(new Date());
  const [endDate, setEndDate] = React.useState(new Date());
  const [submittedFilters, setSubmittedFilters] = React.useState(null);
  const [submitDisable, setSubmitDisable] = React.useState(true);
  const allMultipleSelects = useSelector((state) => state.stores);
  const component =
    allMultipleSelects.findIndex((el) => el.componentName === "suspicious") ==
    -1
      ? 0
      : allMultipleSelects.findIndex((el) => el.componentName === "suspicious");

  const selectedStatus = useSelector((state) => state.selectBox.selectedValue);
  const dispatcher = useDispatch();

  useEffect(() => {
    dispatcher(addMultipleSelect({ componentName: "suspicious" }));
  }, []);

  useEffect(() => {
    axios
      .get(`${API_BASE}/storesDetail`, {
        params: {
          storeNumber: true,
        },
      })
      .then((res) => {
        dispatcher(
          setAllItems({
            componentName: "suspicious",
            allItems: res.data.nameNumber,
          }),
        );
        dispatcher(
          setItemsList({
            componentName: "suspicious",
            ItemsList: res.data.nameNumber,
          }),
        );
      });
  }, []);

  useEffect(() => {
    if (allMultipleSelects[component].items.length == 0) {
      setSubmitDisable(true);
    } else {
      setSubmitDisable(false);
    }
  }, [allMultipleSelects[component].items]);

  const { data: rows = [], isFetching } = useSuspiciousTransactions(
    submittedFilters,
    submittedFilters !== null,
  );
  const updateTransaction = useUpdateTransaction();

  const handleStartDateChange = (date) => {
    setStartDate(date);
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setSubmittedFilters({
      statusRequest: selectedStatus.selectedValue,
      stores: allMultipleSelects[component].items,
      startDate: startDate,
      endDate: endDate,
      allStores: allMultipleSelects[component].allItemsSelected,
    });
  };

  const options = ["Suspicious", "Cleared", "Fraud", "Employee Discount"];
  const defaultStatus = ["Suspicious", "Cleared", "Fraud", "Employee Discount"];

  return (
    <>
      <form noValidate onSubmit={handleSubmit}>
        <Box pt={5} pb={5} pl={2}>
          <Grid container spacing={7}>
            <Grid item md={2} xs={2}>
              {isFetching && (
                <Backdrop style={{ zIndex: 2 }} open={true}>
                  <Bars type="Watch" color="#862D23" height="100" width="100" />
                </Backdrop>
              )}
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  variant="inline"
                  inputVariant="outlined"
                  label="Start Date"
                  value={startDate}
                  onChange={handleStartDateChange}
                ></DatePicker>
              </LocalizationProvider>
            </Grid>
            <Grid item md={2} xs={2}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  variant="inline"
                  inputVariant="outlined"
                  label="End Date"
                  value={endDate}
                  onChange={handleEndDateChange}
                ></DatePicker>
              </LocalizationProvider>
            </Grid>
            <Grid item md={2} xs={2}>
              <SelectBox options={options} defaultStatus={defaultStatus} />
            </Grid>
            <Grid item md={3} xs={3} style={{ marginTop: 8 }}>
              <StoresDropDown
                componentName={"suspicious"}
                componentType={"stores"}
                width={300}
              />
            </Grid>
            <Grid item style={{ marginTop: 22 }}>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                disabled={submitDisable}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </Box>
      </form>

      <Grid item md={12} xs={12}>
        <CollapsibleTable
          rows={rows}
          statuses={["Cleared", "Suspicious", "Fraud"]}
          onUpdate={(row, edits) =>
            updateTransaction.mutateAsync({ row, ...edits })
          }
        />
      </Grid>
    </>
  );
}

export default SuspiciousTable;
